import './App.css';
import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';

// Componentes
import Login from './components/Login.js';
import Loader from './components/Loader.js';
import Registro from './components/Registro.js';

//helpers
import { getCookie, checkCookies, toDate } from './utils/helpers';

//views
import VistaNitro from './views/VistaNitro.jsx';
import VistaLevel from './views/VistaLevel';
import Visor from './views/Visor.js';
import EnlaceView from './views/EnlaceView.jsx';



const App = () => {

const params = new URLSearchParams(window.location.search);
const initialView = params.get('view');
const [name, setName] = useState(initialView || window.name || 'nitro');
//const [isLoading, setIsLoading] = useState(initialView === 'visor' ? false : true);
const [isLoading, setIsLoading] = useState(
  (initialView === 'visor' || initialView === 'enlace') ? false : true
);

const isVisor = initialView === 'visor' || window.name === 'visor';
const [auth, setAuth] = useState(isVisor);
 
const [appVersion, setAppVersion] = useState(() => getCookie('appVersion') || null);


  //const [isLoading, setIsLoading] = useState(true);
  const [datos, setData] = useState(null);
  const [array, setArray] = useState(null);
  //const [name, setName] = useState('nitro');
  //const [name, setName] = useState(window.name || 'nitro');//Esto permite que si la pestaña se abrió con window.name = 'visor', entonces al cargar el componente <App />, se renderizará Visor
  //const [auth, setAuth] = useState(false);
  const [user, setUser] = useState('---');
  const [apiKey, setApiKey] = useState(null);
  const [cookies, setCookie, removeCookie] = useCookies(['session_id', 'user']);
  const [filter, setFilter] = useState('ALL');

  const logout = () => {
    removeCookie('session_id', { path: '/' });
    removeCookie('user', { path: '/' });
    window.location.reload(false);
  };

  const updateNitro = () => {
    
    const host = window.location.hostname;
    const isProd = process.env.NODE_ENV === 'production';
    /*const url = isProd
    ? 'api/updateAll/'
    : `http://${host}/react_projects/ISIGHT_v2/src/api/updateAll/`; //para conectar ipad o ipone por red
    */
    const url = isProd
    ? 'api/updateAll/'
    : `/api_react_test/updateAll/`; //para conectar ipad o ipone por red !!!!! esto conecta con el servidor remoto..! ya que en package.json se puso ", proxy: http://www.isight.cl  asi que ahora /api_react_test/updateAll/ se va directo al servidor ahorrando tiempo de ejecución y evitando fallas de CORS..!!!  30-07-2025"
    // SOLO HAY QUE CONSIDERAR QUE LOS PHP EDITADOS DEBEN SUBIRSE A /api_react_test/ EN EL SERVIDOR



    checkCookies(removeCookie);

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        task: 'get',
        Authorization: 'Client-ID ' + cookies.session_id
      })
    })
      .then((res) => res.json())
      .then((i) => {
        setData(i);
        setIsLoading(false);
        setArray(Array((Object.keys(i).length)).fill('1'));

        if (typeof i.auth === 'undefined' || i.auth === false) {
          setAuth(false);
          removeCookie('session_id', { path: '/' });
          removeCookie('user', { path: '/' });
          window.location.reload(false);
        } else {
          setAuth(true);
        }
      })
      .catch((err) => {
        console.log('Error de sesión:\n' + err);
      });
  };

  /*useEffect(() => {
    const api = cookies.session_id;
    const mail = cookies.user;
    if (api && api.length > 10) {
      setAuth(true);
      setUser(mail);
    }
  }, []);
  */
 useEffect(() => {
  const api = cookies.session_id;
  const mail = cookies.user;
  if (api && api.length > 10) {
    if (name !== 'visor') {
      setAuth(true);
    }
    setUser(mail);
  }
}, [name]);

  /*useEffect(() => {
    if (auth && name !== 'test') {
      updateNitro();
      const intervalId = setInterval(updateNitro, 30000);
      return () => clearInterval(intervalId);
    }
  }, [auth]);
  */

  useEffect(() => {
  if (auth && name !== 'test' && name !== 'visor') {
      updateNitro();
      const intervalId = setInterval(updateNitro, 30000);
      return () => clearInterval(intervalId);
    }
  }, [auth, name]);


  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const viewParam = params.get('view');

  if (viewParam === 'enlace') {
    setName('enlace');
    setAuth(true);     // <-- EXACTAMENTE lo mismo que visor: permite entrar
  }
}, []);



/*
  useEffect(() => {
    if (window.name === 'visor') {
      setAuth(true);
    }
  }, []);
*/

  useEffect(() => {

     let interval;

    let urlv = process.env.NODE_ENV === 'production'
      ? 'api/version/refreshonversion.php'
      : 'http://localhost/react_projects/ISIGHT_v2/src/api/version/refreshonversion.php';

    const checkVersion = () => {
      fetch(urlv, { cache: 'no-store' })
        .then((res) => res.json())
        .then((data) => {
          const serverVersion = data.version;
          const storedVersion = getCookie('appVersion');

          // Actualiza SIEMPRE el estado con lo que diga el servidor
          setAppVersion(serverVersion);

          if (serverVersion !== storedVersion) {
            setCookie('appVersion', serverVersion, { path: '/', maxAge: 86400 });
            window.location.reload(true);
          }
        })
        .catch((err) => console.error('Error al consultar versión:', err));
    };

    const timeout = setTimeout(() => {
      checkVersion();
      interval = setInterval(checkVersion, 60000);
      return () => clearInterval(interval);
    }, 30000);

    //return () => clearTimeout(timeout);
      return () => {
      clearTimeout(timeout);
      clearInterval(interval);
  };

  }, []);

  const handleShow = (value) => {
    setFilter(value);
  };


/*
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const viewParam = params.get('view');//get url name (visor)

  if (viewParam === 'visor') {//if visor name is true make a session var for auth
    const cameFromNitro = sessionStorage.getItem('from_nitro');

    if (cameFromNitro === 'true') {
      sessionStorage.removeItem('from_nitro');
      setName('visor');
      setAuth(true);
    } else {
      // Elimina "?view=visor" de la URL antes de redirigir a login
      const cleanUrl = window.location.origin;
      window.history.replaceState({}, '', cleanUrl);
      setName('login');
    }
  }
}, []);
*/
/*
useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const viewParam = params.get('view'); // get url name (visor)

  if (viewParam === 'visor') {
    //const cameFromNitro = sessionStorage.getItem('from_nitro');
    const cameFromNitro = localStorage.getItem('from_nitro');


    if (cameFromNitro === 'true') {
      //sessionStorage.removeItem('from_nitro');
      localStorage.removeItem('from_nitro');

      setName('visor');
      setAuth(true);
    } else {
      // Espera antes de limpiar la URL para no perder parámetros
      setName('visor');
      setAuth(true); // permitir acceso directo al visor

      setTimeout(() => {
        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, '', cleanUrl);
      }, 500); // espera 500ms antes de limpiar los parámetros
    }
  }
}, []);
*/

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const viewParam = params.get('view');
  const token = params.get('token');

  if (viewParam === 'visor') {
    if (token === 'abc123') {  // <<=== TOKEN ESTÁTICO AQUÍ
      setName('visor');
      setAuth(true);
    } else {
      setName('login');
    }
  }
}, []);









  // Render loaders, login, registro
  if (name === 'loader') return <div className="App"><Loader /></div>;
  if (name === 'registro') return <div className="App"><Registro setName={setName} /></div>;

  // Vista 'enlace'
if (name === 'enlace') {
  return (
    <EnlaceView />
  );
}

  if (!auth) return (
    <div className="App">
      <Login loginSet={setAuth} userSet={setUser} apiSet={setApiKey} setCookie={setCookie} setName={setName} removeCookie={removeCookie} />
    </div>
  );
  if (isLoading) return <div className="App"><Loader /></div>;

  // Vista 'level'
  if (name === 'level' && auth && datos?.data) {
    return (
      <VistaLevel
        user={user}
        logout={setAuth}
        setName={setName}
        datos={datos}
        filter={filter}
        handleShow={handleShow}
      />
    );
  }

  // Vista 'nitro'
  if (name === 'nitro' && auth && datos?.data) {
    return (
      <VistaNitro
        user={user}
        logout={setAuth}
        setName={setName}
        datos={datos}
        filter={filter}
        handleShow={handleShow}
        appVersion={appVersion} 
      />
    );
  }


  // Vista 'visor'
  if (name === 'visor') {
    return <Visor 
      user={user}
      logout={setAuth}
      />;
  }





  // Fallback
  return (
    <div className="App">
      <Login loginSet={setAuth} userSet={setUser} apiSet={setApiKey} setCookie={setCookie} setName={setName} removeCookie={removeCookie} />
    </div>
  );
};

export default App;
